<template>
  <div>
    <div class="bg mb10">
      <!--<div class="mb20">
        <span class="font-style">促销类型：</span>
        <el-select
          size="small"
          style="width:200px"
          placeholder="请选择促销类型"
          v-model="searchCondition.promotionCode"
          class="ml10"
          @change="promotionCodeChange"
          filterable
        >
          <el-option
            v-for="item in activityTypeList"
            :key="item.promotionCode"
            :label="item.typeName"
            :value="item.promotionCode"
          ></el-option>
        </el-select>
      </div>-->
      <div class="mb20">
        <span class="font-style">促销名称：</span>
        <el-tag
          @close="handleClose(i, 'activityNameList')"
          v-for="(tag, i) in activityNameList"
          :key="i"
          closable
          class="mr10"
        >
          {{ tag.promotionName }}
        </el-tag>
        <el-button class="ml10" type="text" size="small" @click="addActivity"
          >修改</el-button
        >
        <!-- <el-select
          size="small"
          style="width:200px"
          placeholder="请选择促销名称"
          v-model="searchCondition.gameId"
          class="ml10"
          filterable
        >
          <el-option
            :label="v.promotionName"
            :value="v.id"
            :key="i"
            v-for="(v, i) in activityNameList"
          ></el-option>
        </el-select> -->
      </div>
      <div>
        <div class="title font-style mb10">
          效果分析
        </div>
        <div class="flex">
          <div class="flex-1">
            <div class="data-title">
              投入产出
            </div>
            <div class="flex">
              <div
                v-for="(v, i) in inputAndOutputList"
                :key="i"
                class="purchase-data p10 flex flex-1 mr20"
              >
                <div class="hm-icon mr10">
                  <span class="hmicon" :class="v.icon"></span>
                </div>
                <div class="flex-1">
                  <div class="purchase-name mt10">
                    {{ v.name }}
                    <el-popover
                      placement="top-start"
                      title="说明"
                      width="300"
                      trigger="hover"
                      v-if="v.name === 'ROI'"
                    >
                      <div>
                        <div class="mb10">
                          统计时间内，营销支付金额 / 营销优惠金额
                        </div>
                      </div>
                      <i class="el-icon-question gray" slot="reference"></i>
                    </el-popover>
                  </div>
                  <div class="mt10">
                    <div class="purchase-val" style="font-size: 17px">
                      {{ v.key === "roi" ? ToFixed(v.val * 100, 2) : ToFixed(v.val, 2) }}
                      {{ v.key === "roi" ? "%" : "" }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style="width:40px"></div>
          <div class="flex-1">
            <div class="data-title">
              销售连带
              <el-popover
                placement="top-start"
                title="说明"
                width="300"
                trigger="hover"
              >
                <div>
                  <div class="mb10">
                    营销支付件数：
                    统计选择活动中，通过营销插件成功付款订单的商品件数之和.
                  </div>
                  <div class="mb10">
                    营销支付订单数：
                    统计选择活动中，通过营销插件成功付款的订单数.
                  </div>
                  <div>
                    营销支付金额： 统计选择活动中，通过营销插件成功付款的订金额.
                  </div>
                </div>
                <i class="el-icon-question gray" slot="reference"></i>
              </el-popover>
            </div>
            <div class="flex">
              <div
                v-for="(v, i) in salesOfJoint"
                :key="i"
                class="purchase-data p10 flex flex-1 mr20"
              >
                <div class="hm-icon mr10">
                  <span class="hmicon" :class="v.icon"></span>
                </div>
                <div class="flex-1">
                  <div class="purchase-name mt10">
                    {{ v.name }}
                  </div>
                  <div class="mt10">
                    <div class="purchase-val" style="font-size: 17px">
                      {{ v.key === "relate" ? ToFixed(v.val * 100, 2) : v.val }}
                      {{ v.key === "relate" ? "%" : "" }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bg mb10">
      <div class="title font-style">
        拉新复购
        <el-popover
          placement="top-start"
          title="说明"
          width="300"
          trigger="hover"
        >
          <div>
            <div class="mb10">
              成交客户数： 统计选择活动中，营销活动支付人数.
            </div>
            <div class="mb10">
              新成交客户：
              过去2年没有购买，在统计选择活动中通过营销插件首次在店铺付款的客户人数.
            </div>
            <div>
              老成交客户：
              过去2年在店铺购买过，在统计选择活动中通过营销插件再次付款的客户人数.
            </div>
          </div>
          <i class="el-icon-question gray" slot="reference"></i>
        </el-popover>
      </div>
      <div class="flex flex-center">
        <ve-ring
          height="400px"
          width="400px"
          :extend="chartExtend"
          :data="ringChartData"
        >
        </ve-ring>
      </div>
    </div>
    <div class="bg mb10">
      <div class="title font-style">
        数据趋势
      </div>
      <div class="mt10">
        <el-radio-group
          v-model="searchCondition.dateType"
          size="small"
          class="mr20"
          @change="dateTypeChange"
        >
          <el-radio-button label="day">天</el-radio-button>
          <el-radio-button label="hour">小时</el-radio-button>
        </el-radio-group>

        <el-radio-group
          v-model="searchCondition.radio4"
          @change="radio4Change"
          size="small"
          class="mr20"
        >
          <el-radio-button label="indicators">指标对比</el-radio-button>
          <el-radio-button label="act">活动对比</el-radio-button>
        </el-radio-group>
      </div>
      <div class="mt10">
        <el-checkbox-group
          v-if="searchCondition.radio4 === 'indicators'"
          v-model="searchCondition.checkboxs"
          @change="checkboxsChange"
          class="flex"
        >
          <el-checkbox
            :disabled="v.disabled"
            v-for="(v, i) in checkboxList"
            :key="i"
            :label="v.value"
            >{{ v.key }}</el-checkbox
          >
        </el-checkbox-group>

        <el-radio-group
          v-model="searchCondition.radio1"
          @change="radio1Change"
          v-else
        >
          <el-radio :label="v.value" v-for="(v, i) in checkboxList" :key="i">{{
            v.key
          }}</el-radio>
        </el-radio-group>
      </div>
      <div class="mt10">
        <ve-line
          height="400px"
          :settings="chartLineSettings"
          :data="chartLineData"
          :extend="{ dataZoom }"
        ></ve-line>
      </div>
    </div>
    <div class="bg">
      <div class="title font-style">
        商品效果
      </div>
      <el-table
        stripe
        ref="table"
        :data="list"
        style="width: 100%"
        size="small"
        @sort-change="sortChange"
      >
        <el-table-column
          type="index"
          label="序号"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="left"
          prop="orderSn"
          label="商品信息"
          width="300"
        >
          <template slot-scope="scope">
            <div class="flex">
              <div class=" flex flex-column  flex-between">
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="scope.row.spuName"
                  placement="top"
                >
                  <div class="goods-name">
                    {{ scope.row.spuName }}
                  </div>
                </el-tooltip>
                <div class="primary">￥{{ scope.row.spuPrice }}</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="goodsNum"
          label="营销支付件数"
          sortable="custom"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="orderNum"
          label="营销支付订单数"
          sortable="custom"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="orderAmount"
          label="营销支付金额"
          sortable="custom"
        >
          <template slot-scope="scope">
            {{ ToFixed(scope.row.orderAmount, 2) }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="promotionAmount"
          label="营销优惠金额"
          sortable="custom"
        >
          <template slot-scope="scope">
            {{ ToFixed(scope.row.promotionAmount, 2) }}
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total,sizes,  prev, pager, next, jumper"
          :current-page="currentPage"
          :page-size="pageSize"
        ></el-pagination>
      </div>
    </div>
    <el-dialog title="选择促销" :visible.sync="dialogVisible" width="1000px">
      <div class="form-item-tip mb10">
        已选促销: 最多支持5个，仅支持3个月内生效的活动
      </div>
      <div>
        <el-tag
          @close="handleClose(i, 'selectActList')"
          v-for="(tag, i) in selectActList"
          :key="i"
          closable
        >
          {{ tag.promotionName }}
        </el-tag>
      </div>
      <div class="mt10">
        <div class="flex flex-end">
          <!-- <el-select
            size="small"
            style="width:200px"
            placeholder="请选择促销类型"
            v-model="searchCondition.promotionCode"
            class="mr10"
            @change="promotionCodeChange"
            filterable
          >
            <el-option
              v-for="item in activityTypeList"
              :key="item.promotionCode"
              :label="item.typeName"
              :value="item.promotionCode"
            ></el-option>
          </el-select> -->
          <el-input
            clearable
            v-model.trim="promotionName"
            placeholder="输入促销名称"
            size="small"
            class="ipt mr10"
          ></el-input>
          <el-button type="primary" size="small" @click="search"
            >查询</el-button
          >
        </div>
      </div>
      <div class="mt10">
        <el-table
          stripe
          :data="activityAllList"
          style="width: 100%"
          id="table"
          size="small"
          ref="multipleTable"
          @selection-change="getChecked"
          border
        >
          <el-table-column type="selection"></el-table-column>
          <el-table-column
            type="index"
            label="序号"
            header-align="center"
            align="center"
            :index="
              index => index + (currentPageActivity - 1) * pageSizeActivity + 1
            "
          ></el-table-column>
          <!-- <el-table-column
            header-align="center"
            align="center"
            label="促销类型"
          >
            <template slot-scope="scope">
              <div class="table-status flex item-center">
                <span
                  class="status success-bg"
                  v-show="scope.row.timeStatus === 'running'"
                ></span>
                <span
                  class="status gray-bg"
                  v-show="scope.row.timeStatus === 'notStarted'"
                ></span>
                <span
                  class="status danger-bg"
                  v-show="scope.row.timeStatus === 'end'"
                ></span>
                <span class="flex flex-1 flex-start">{{
                  scope.row.typeName
                }}</span>
              </div>
            </template>
          </el-table-column> -->
          <el-table-column
            header-align="center"
            align="center"
            prop="promotionName"
            label="促销名称"
          >
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                :content="scope.row.promotionName"
                placement="top"
              >
                <div class="flex item-center">
                  <span class="pos" v-if="scope.row.createMode">
                    p
                  </span>
                  <span class="time flex-1 text-overflow">
                    {{ scope.row.promotionName }}
                  </span>
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            width="300px"
            prop="startDateFormat"
            label="促销时间"
          >
            <template slot-scope="scope">
              <span class="time">
                {{ scope.row.startDate }}至{{ scope.row.endDate }}
              </span>
            </template>
          </el-table-column>

          <el-table-column
            header-align="center"
            align="center"
            prop="enabledState"
            label="促销状态"
          >
            <template slot-scope="scope">
              <span
                class="status danger"
                v-show="scope.row.enabledState === 'disabled'"
                >下线</span
              >
              <span
                class="status success"
                v-show="scope.row.enabledState === 'enable'"
                >上线</span
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="hm-pagination">
          <el-pagination
            background
            :total="totalActivity"
            @current-change="pagingActivity"
            @size-change="handleSizeChangeActivity"
            layout="total,sizes,  prev, pager, next, jumper"
            :current-page="currentPageActivity"
            :page-size="pageSizeActivity"
          ></el-pagination>
        </div>
      </div>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button size="small" type="primary" @click="save">确 定</el-button>
        <el-button size="small" @click="close">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import veRing from "v-charts/lib/ring.common";
import VeLine from "v-charts/lib/line.common";
import { arrayUnique2, ToFixed } from "@/utils/utils";
export default {
  components: {
    veRing,
    VeLine
  },
  data() {
    return {
      promotionName: "",
      dialogVisible: false,
      list: [{}],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      currentPageActivity: 1,
      pageSizeActivity: 10,
      totalActivity: 0,
      searchCondition: {
        promotionCode: "",
        gameId: "",
        dateType: "day",
        radio4: "indicators",
        checkboxs: ["centerNum", "newCenterNum", "oldCenterNum", "goodsNum"],
        radio1: "centerNum"
      },
      activityTypeList: [],
      activityNameList: [],
      activityAllList: [],
      selectActList: [],
      inputAndOutputList: [
        {
          icon: "icon-zongrenshu",
          key: "roi",
          name: "ROI",
          val: "0"
        },
        {
          icon: "icon-fukuanrenshu",
          key: "orderAmount",
          name: "营销支付金额",
          val: "0"
        },
        {
          icon: "icon-fukuanjine",
          key: "promotionAmount",
          name: "营销优惠金额",
          val: "0"
        }
      ],
      salesOfJoint: [
        {
          icon: "icon-a-yingxiao-dianjihou2x",
          key: "goodsNum",
          name: "营销支付件数",
          val: "0"
        },
        {
          icon: "icon-fugoudingdanshu1",
          key: "orderNum",
          name: "营销支付订单数",
          val: "0"
        },
        {
          icon: "icon-fukuanjine",
          key: "relate",
          name: "连带率",
          val: "0"
        }
      ],
      chartExtend: {
        graphic: [
          {
            //环形图中间添加文字
            type: "text", //通过不同top值可以设置上下显示
            left: "center",
            top: "45%",
            style: {
              text: "成交客户数" + "\n" + "\n" + 0,
              textAlign: "center",
              fill: "#000", //文字的颜色
              width: 30,
              height: 40,
              fontSize: 16,
              fontWeight: 600,
              fontFamily: "Microsoft YaHei",
              lineHeight: 40
            }
          }
        ]
      },
      ringChartSettings: {
        dimension: "old",
        metrics: "new",
        radius: ["60px", "80px"],
        label: {
          rich: {
            a: {
              color: "#438de7"
            },
            b: {
              color: "#7b7d86"
            }
          }
        }
      },
      ringChartData: {
        columns: ["key", "value"],
        rows: [
          { key: "新成交客户", value: 0 },
          { key: "老成交客户", value: 0 }
        ]
      },
      checkboxList: [
        {
          key: "营销支付人数",
          value: "centerNum",
          disabled: false
        },
        {
          key: "新成交客户",
          value: "newCenterNum",
          disabled: false
        },
        {
          key: "老成交客户",
          value: "oldCenterNum",
          disabled: false
        },
        {
          key: "营销支付件数",
          value: "goodsNum",
          disabled: false
        },
        {
          key: "营销支付订单数",
          value: "orderNum",
          disabled: false
        },
        {
          key: "营销支付金额",
          value: "orderAmount",
          disabled: false
        },
        {
          key: "客单价（元）",
          value: "perPrice",
          disabled: false
        }
      ],
      chartLineSettings: {
        labelMap: {
          date: "日期"
        }
      },
      chartLineData: {
        columns: [
          "date",
          "centerNum",
          "newCenterNum",
          "oldCenterNum",
          "goodsNum"
        ],
        rows: [
          // {
          //   date: "2019-1月1日",
          //   centerNum: 123,
          //   newCenterNum: 123,
          //   oldCenterNum: 99
          // },
          // {
          //   date: "2019-2月1日",
          //   centerNum: 1231,
          //   newCenterNum: 1232,
          //   oldCenterNum: 299
          // },
          // {
          //   date: "2019-3月1日",
          //   centerNum: 1123,
          //   newCenterNum: 1223,
          //   oldCenterNum: 399
          // }
          // { 日期: "1月2日", 非分销订单: 1223, 分销订单: 123 },
          // { 日期: "1月3日", 非分销订单: 2123, 分销订单: 1223 },
          // { 日期: "1月4日", 非分销订单: 4123, 分销订单: 123 },
          // { 日期: "1月5日", 非分销订单: 3123, 分销订单: 123 },
          // { 日期: "1月6日", 非分销订单: 7123, 分销订单: 123 }
        ]
      },
      dataZoom: [
        {
          start: 0,
          type: "inside",
          show: true
        }
      ],
      oldCenterNum: 0,
      newCenterNum: 0,
      ToFixed
    };
  },
  created() {},
  mounted() {
    this.searchCondition.promotionCode = this.$route.query.promotionCode;
    this.activityNameList = [
      {
        promotionName: this.$route.query.promotionName,
        id: this.$route.query.id
      }
    ];
    this.checkboxList.forEach(v => {
      this.chartLineSettings.labelMap[v.value] = v.key;
    });
    this.initReq();
  },
  methods: {
    initReq() {
      this.queryActivityTypeList();
      this.promotionStatInforoi();
      this.targetTrend();
      this.activeTrend();
      this.queryList();
      this.disabledCheck();
    },
    dateTypeChange() {
      this.targetTrend();

      this.activeTrend();
    },
    radio4Change() {
      // this.targetTrend();
      this.disabledCheck();
    },
    async targetTrend() {
      let params = {
        dateType: this.searchCondition.dateType,
        promotionIdList: this.activityNameList.map(v => v.id)
      };
      if (this.searchCondition.radio4 === "indicators") {
        this.searchCondition.checkboxs = [
          "centerNum",
          "newCenterNum",
          "oldCenterNum",
          "goodsNum"
        ];
        const { result } = await this.$store.dispatch("targetTrend", params);
        this.copyTargetTrend = JSON.parse(JSON.stringify(result));
        this.chartLineData.rows = result;
      } else if (this.searchCondition.radio4 === "act") {
        // this.searchCondition.radio1 = "centerNum";
        // const { result } = await this.$store.dispatch("activeTrend", params);
        // this.copyActiveTrend = JSON.parse(JSON.stringify(result));
        // this.switchAct();
      }
    },
    async activeTrend() {
      let params = {
        dateType: this.searchCondition.dateType,
        promotionIdList: this.activityNameList.map(v => v.id)
      };
      // this.searchCondition.radio1 = "centerNum";
      const { result } = await this.$store.dispatch("activeTrend", params);
      this.copyActiveTrend = JSON.parse(JSON.stringify(result));
      this.switchAct();
    },
    switchAct() {
      if (this.searchCondition.radio4 === "act") {
        this.chartLineData.columns = [];
        this.chartLineData.rows = [];

        for (let key in this.copyActiveTrend[0]) {
          this.chartLineData.columns.push(key);
        }

        this.copyActiveTrend.forEach(v => {
          let params = {};
          for (let key in v) {
            params[key] =
              key === "date" ? v[key] : v[key][this.searchCondition.radio1];
          }
          this.chartLineData.rows.push(params);
        });
      }
    },
    async promotionStatInforoi() {
      let params = {
        promotionIdList: this.activityNameList.map(v => v.id)
      };
      const { result } = await this.$store.dispatch(
        "promotionStatInforoi",
        params
      );
      this.inputAndOutputList.forEach(v => {
        v.val = result[v.key];
      });
      this.salesOfJoint.forEach(v => {
        v.val = result[v.key];
      });
      this.oldCenterNum = result.oldCenterNum;
      this.newCenterNum = result.newCenterNum;
      this.ringChartData.rows[0].value = this.newCenterNum;
      this.ringChartData.rows[1].value = this.oldCenterNum;
      this.chartExtend.graphic[0].style.text = `成交客户数\n\n${this
        .newCenterNum + this.oldCenterNum}`;
    },
    search() {
      this.currentPageActivity = 1;
      this.queryActivityList();
    },
    async queryActivityList() {
      const params = {
        pageSize: this.pageSizeActivity,
        pageNo: this.currentPageActivity,
        promotionCode: this.searchCondition.promotionCode,
        promotionName: this.promotionName,
        auditState: "audit_pass",
        timeStatus: "all"
      };

      const { result } = await this.$store.dispatch(
        "queryActivityList",
        params
      );
      const { records, total } = result.activityList;
      this.activityAllList = records;
      // setTimeout(() => {
      //   this.activityAllList.forEach(v => {
      //     if (this.selectActList.findIndex(o => o.id === v.id) > -1) {
      //       this.$refs.multipleTable.toggleRowSelection(v, true);
      //     }
      //   });
      // }, 10);

      this.totalActivity = total;
    },
    addActivity() {
      this.dialogVisible = true;
      this.selectActList = JSON.parse(JSON.stringify(this.activityNameList));
      this.queryActivityList();
    },
    promotionCodeChange() {
      this.queryActivityList();
    },
    sortChange(sort) {
      this.sort = {
        order: sort.order,
        prop: sort.prop
      };
      this.queryList();
    },
    checkboxsChange() {
      this.disabledCheck();
      // console.log("this.checkboxList: ", this.checkboxList);

      // this.chartLineData.columns =JSON.parse(JSON.stringify(val))
    },
    radio1Change() {
      this.switchAct();
    },
    disabledCheck() {
      this.checkboxList.forEach(v => {
        v.disabled = false;
      });
      if (this.searchCondition.radio4 === "indicators") {
        if (this.searchCondition.checkboxs.length >= 4) {
          this.checkboxList.forEach(v => {
            if (
              this.searchCondition.checkboxs.findIndex(o => o === v.value) < 0
            ) {
              v.disabled = true;
            }
          });
        } else {
          this.checkboxList.forEach(v => {
            v.disabled = false;
          });
        }
        this.chartLineData.columns = [...this.searchCondition.checkboxs];
        this.chartLineData.columns.unshift("date");
        this.chartLineData.rows = this.copyTargetTrend;
      } else if (this.searchCondition.radio4 === "act") {
        this.switchAct();
        // if (this.searchCondition.checkboxs.length >= 1) {
        //   this.checkboxList.forEach(v => {
        //     if (
        //       this.searchCondition.checkboxs.findIndex(o => o === v.value) < 0
        //     ) {
        //       v.disabled = true;
        //     }
        //   });
        // } else {
        //   this.checkboxList.forEach(v => {
        //     v.disabled = false;
        //   });
        // }
        // this.chartLineData.columns = [...this.searchCondition.checkboxs];
        // this.chartLineData.columns.unshift("date");
        // console.log("this.chartLineData: ", this.chartLineData);
      }
    },
    async queryActivityTypeList() {
      const { result } = await this.$store.dispatch(
        "queryActivityCategoryList"
      );
      let list = [];

      result.forEach(v => {
        list = list.concat(v.nodes);
      });

      this.activityTypeList = list;
    },

    async queryList() {
      const params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
        promotionIdList: this.activityNameList.map(v => v.id)
      };
      // const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, this.sort);
      const { code, result } = await this.$store.dispatch(
        "storeOrderPromotionGoodsInfo",
        params
      );
      if (code === "0") {
        const { total, records } = result;
        this.list = records;
        this.total = total;
      }
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    pagingActivity(page) {
      this.currentPageActivity = page;
      this.queryActivityList();
    },
    handleSizeChangeActivity(size) {
      this.currentPageActivity = 1;
      this.pageSizeActivity = size;
      this.queryActivityList();
    },
    getChecked(selection) {
      console.log("selection: ", selection);
      // setTimeout(() => {
      this.selectActList.push(...selection);
      this.selectActList = arrayUnique2(this.selectActList, "id");
      // }, 20);
    },
    save() {
      if (this.selectActList.length > 5) {
        this.$message({
          message: "最多选择5个活动",
          type: "warning"
        });
        return;
      }
      this.dialogVisible = false;

      this.activityNameList = this.selectActList;
      this.initReq();
    },
    close() {
      this.dialogVisible = false;
    },
    handleClose(i, list) {
      if (this[list].length === 1) {
        this.$message({
          message: "最少保留1个活动",
          type: "warning"
        });
        return;
      }
      this[list].splice(i, 1);
    }
  }
};
</script>

<style scoped lang="scss">
.bg {
  background: #ffffff;
  padding: 20px;
}
.font-style {
  font-weight: bold;
  font-size: 15px;
}
.title {
  color: #222222;
  font-weight: bold;
  &::before {
    display: inline-block;
    margin-right: 5px;
    content: "";
    width: 4px;
    height: 14px;
    background: #e50065;
    border-top-left-radius: 30px;
    border-bottom-right-radius: 30px;
  }
}
.data-title {
  font-size: 14px;
  line-height: 28px;
}
.purchase-data {
  box-shadow: 0px 0px 12px 0px rgba(221, 221, 221, 0.6);
  border-radius: 6px;
  &:last-child {
    margin-right: 0;
  }
  .hm-icon {
    width: 66px;
    height: 66px;
    border-radius: 50%;
    text-align: center;
    line-height: 66px;
    background: #feeef5;
    .hmicon {
      font-size: 25px;
      color: #e50065;
    }
  }
  .purchase-name {
    color: #222222;
    font-size: 14px;
  }
  .purchase-val {
    font-size: 24px;
    font-weight: bold;
  }
}
.goods-name {
  width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2; /*行数*/
  font-size: 14px;
}
.el-icon-question {
  font-size: 16px;
}
</style>
